/* eslint-disable */
import React from 'react';
import envGet from '../../Support/Env/Get/EnvGet.support';

const REACT_APP_VERSION = envGet({ key: `REACT_APP_VERSION` });
const [REACT_APP_ENV] = envGet({ key: `REACT_APP_ENV` });
const styles = {
  bottom: 10,
  color: `darkgrey`,
  fontFamily: `monospace`,
  fontSize: `0.75rem`,
  left: 14,
  position: `fixed`,
};

/**
 * Render the app info component
 * @returns {React.Component} The rendered app info component
 */
const AppInfo = () => (
  <div style={styles}>
    {`v.${REACT_APP_VERSION}(${REACT_APP_ENV})`}
  </div>
);

export default AppInfo;
